import React, {useEffect, useState} from 'react';
import axios from "axios";
import {toast} from "react-toastify";
import {useHistory} from "react-router-dom";
import {API_PATH} from "../../components/const";

const Register = () => {
    const [userName, setUserName] = useState("admin")
    const [pass, setPass] = useState("ping1234")
    const [email, setEmail] = useState("@gmail.com")
    const [compName, setCompName] = useState("")
    const [pic, setPic] = useState(null);
    const [show, setShow] = useState(false)
    const [step, setStep] = useState(2)
    let history = useHistory()
    const Next = () => {
        // "username": "string",
        //     "email": "string",
        //     "password": "string",
        //     "is_superuser": false,
        //     "role_id": 0
       axios.post(API_PATH + "user", {
           username: userName,
           password: pass,
           is_superuser: true,
           email: email,
           role_id: 1,
       })
           .then(res =>{
               // console.log(res?.data)
               // localStorage.setItem("token", )
               localStorage.setItem("role", res?.data?.role?.name)
               toast.success("Создано успешно")
               setStep(3)
               let newData = new FormData()
               newData.append('username', userName)
               newData.append('password', pass)
               newData.append('scope', "snapshot:read camera:write camera:read admin:read admin:write line_crossing_analytics:write module:read module:write fleet:read fleet:write config:read config:write line_crossing_analytics:read line_crossing_analytics:write analitiks:read")
               setTimeout(() => {

               axios.post(API_PATH + "token", newData)
                   .then(res => {
                       localStorage.setItem("token", res.data?.access_token)
                       localStorage.setItem("first_name", res.data?.user_info?.first_name)
                       localStorage.setItem("last_name", res.data?.user_info?.last_name)
                       localStorage.setItem("username", res.data?.user_info?.username)
                       localStorage.setItem("phone_user", res.data?.user_info?.phone)
                       localStorage.setItem("image", res.data?.user_info?.image)
                       }, 300)
                   })
                   .catch(err => {
                       toast.error("Ошибка")
                   })
           })
           .catch(err =>{
               // console.log(err)
               toast.error(err.response?.data?.detail)
           })
    }

    const createCompany = () => {
        let bigData = new FormData()
        if (pic.target.files[0]) {
            bigData.append("logo", pic.target.files[0])
        }
        bigData.append("name", compName)
            axios.post(API_PATH + "company/create",
                bigData
      ,{headers: {"Authorization": "Bearer " + localStorage.getItem("token")}})
                .then(res =>{
                    toast.success("Создано успешно")
                    localStorage.setItem("for_com", res?.data?.id)

                    setTimeout(() => {
                        history.push("/main/visitor-home")
                    }, 300)
                })
    }
    return (
        <div className="main-login">
            <div className="login-top-title">
                <p>Добро пожаловать в <br/> <img className="mt-20" src="/icon/loginlogo.svg" alt="..."/></p>
                <h2>
                </h2>
            </div>

            <div className="main-steps">
                <div>
                    <button className="active-step" onClick={() => setStep(1)}><span>1</span></button>
                    <span className="main-steps-title">Подключить ключ</span>
                </div>

                {
                    step === 2 || step === 3 ?
                        <img src="/icon/Line295.svg" alt=".............."/>
                        :
                        <img src="/icon/Line294.svg" alt=".............."/>
                }

                <div>
                    <button className={step === 2 || step === 3 ? "active-step" : ""}
                            onClick={() => setStep(2)}>
                        <span>2</span></button>
                    <span className="main-steps-title">Создать пользователя</span>
                </div>
                {
                    step === 3 ?
                        <img src="/icon/Line295.svg" alt=".............."/>
                        :
                        <img src="/icon/Line294.svg" alt=".............."/>
                }
                <div>
                    <button className={step === 3 ? "active-step" : ""} onClick={() => setStep(3)}>
                        <span>3</span>
                    </button>
                    <span className="main-steps-title">Создать компанию</span>
                </div>
            </div>
            {
                step === 1 ?
                    <div className="login-box">
                        <div className="login-inputs">
                            <h3>Регистрация</h3>
                            <div className="inputs-box">
                                <label className="font-family-medium" >Ключ</label>
                                <input type="text" 
                                       placeholder="Введите свой ключ"/>
                                <p className="mb-0">Чтобы взять его, свяжитесь с нами
                                    0/0</p>
                            </div>

                            <button onClick={Next}  className="login-btn">Следующий</button>
                        </div>
                    </div>
                    : step === 2 ?
                        <div className="login-box" style={{marginTop: "50px !important"}}>
                            <div className="login-inputs">
                                <h3>Создать пользователя</h3>
                                {/*<div className="inputs-box">*/}
                                {/*    <label className="font-family-medium" >Полное имя</label>*/}
                                {/*    <input type="text"*/}
                                {/*           placeholder="Введите полное имя"/>*/}
                                {/*</div>*/}
                                {/*<div className="inputs-box password-eye">*/}
                                {/*    <label className="font-family-medium" >Загрузить изображение</label>*/}
                                {/*    <div className="position-relative">*/}
                                {/*        <input type="file"*/}
                                {/*        />*/}
                                {/*        <button>*/}
                                {/*            <img src="/icon/uploadbtn.svg" alt=""/>*/}
                                {/*        </button>*/}
                                {/*    </div>*/}
                                {/*</div>*/}
                                <div className="inputs-box">
                                    <label className="font-family-medium" >Email</label>
                                    <input type="text"
                                           value={email}
                                           onChange={(e) => setEmail(e.target.value)}
                                           placeholder="Введите email"/>
                                </div>
                                <div className="inputs-box">
                                    <label className="font-family-medium" >Логин</label>
                                    <input type="text"
                                           onChange={(e) => setUserName(e.target.value)}
                                           value={userName}
                                           placeholder="Создать логин"/>
                                </div>
                                <div className="inputs-box password-eye">
                                    <label className="font-family-medium" >Пароль</label>
                                   <div className="position-relative">
                                       <input type={show ? "text" : "password"}
                                              placeholder="Придумайте пароль"
                                              onChange={(e) => setPass(e.target.value)}
                                              value={pass}
                                       />
                                       <button onClick={() => setShow(!show)}>
                                           <img src="/icon/eye.svg" alt=""/>
                                       </button>

                                   </div>
                                    <p className="mb-0">Должно быть не менее 8 символов.</p>

                                </div>

                                <button onClick={Next}  className="login-btn">Следующий</button>
                            </div>
                        </div>
                        : step === 3 ?
                            <div className="login-box">
                                <div className="login-inputs">
                                    <h3>Создать компанию</h3>
                                    <div className="inputs-box">
                                        <label className="font-family-medium" >Название компании</label>
                                        <input type="text"
                                               value={compName}
                                               onChange={(e) => setCompName(e.target.value)}
                                               placeholder="Введите название компании"/>
                                    </div>
                                    <div className="inputs-box password-eye">
                                        <label className="font-family-medium" >Загрузить логотип</label>
                                        {/*<input type="text"   */}
                                        {/*       placeholder="Загрузите файл .png размером 32x114 пикселей."/>*/}
                                        <div className="position-relative">
                                            <input type="file"
                                                   onChange={(e) => setPic(e)}
                                                   placeholder="Загрузите файл .png размером 32x114 пикселей."
                                            />
                                            <button>
                                                <img src="/icon/uploadbtn.svg" alt=""/>
                                            </button>
                                        </div>
                                    </div>

                                    <button onClick={createCompany}  className="login-btn">Следующий</button>
                                </div>
                            </div>
                            :
                            ""

            }

            <div></div>
            {
                step === 1 ?
                    <div className="bottom-contact-info">
                        <div className="bottom-contact-info-item">
                            <div>
                                <img src="/icon/phonelogo.svg" alt="."/>
                            </div>
                            <div>
                                <span>+998 95 252 66 00</span>
                                <span>||</span>
                                <a href="tel:+998952526600" className="phonelogo">Qo’ng’iroq qilish</a>
                            </div>
                        </div>
                        <div className="bottom-contact-info-item">
                            <div>
                                <img src="/icon/tglogo.svg" alt="."/>
                            </div>
                            <div>
                                <span> @sardorbekataxanov12</span>
                                <span>||</span>
                                <a target="_blank" href="https://telegram.me/sardorbekataxanov12" className="tglogo">Havolaga o’tish</a>
                            </div>
                        </div>
                        <div className="bottom-contact-info-item">
                            <div>
                                <img src="/icon/maillogo.svg" alt="."/>
                            </div>
                            <div>
                                <span>admin@cradle-vision.com</span>
                                <span>||</span>
                                <a target="_blank" href="https://mail.google.com/mail/?view=cm&fs=1&to=admin@cradle-vision.com" className="maillogo">Havolaga o’tish</a>
                            </div>
                        </div>
                    </div>
                    :
                    ""
            }

        </div>
    );
};

export default Register;
